export const APP_ROUTES = {
  HARD_RELOAD: '/hard-reload',
  SETUP: '/setup',
  TTW: '/ttw',
} as const;
